import Alpine from 'alpinejs';
import { initializeReactComponents } from './react.jsx';


// Components

// Global
window.Alpine = Alpine;

// Inits 
Alpine.start();

// Initialize React components after DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    initializeReactComponents();
});




/**
 * Hoogte van de boekingsform-iframe.
 *
 * De form staat cross-origin, dus we kunnen zijn hoogte niet meten. Het externe
 * ritagendaform.js van de leverancier vangt daarvoor postMessage's op, maar past
 * alleen hoogtes boven 540 toe. De bevestigingspagina na betaling stuurt
 * helemaal geen hoogte, en dan blijft de iframe op de HTML-default van 150px
 * staan terwijl de inhoud ruim 800px nodig heeft — de reserveringsgegevens
 * vielen daardoor weg.
 *
 * Deze handler vult dat aan: hij accepteert ook kleinere gerapporteerde hoogtes,
 * en valt terug op een ruime hoogte als er niets binnenkomt. Zodra de
 * leverancier de bevestigingspagina wél laat rapporteren, neemt die waarde het
 * over en is de terugval niet meer nodig.
 */
const BOOKING_IFRAME_ID = 'ritagenda_bookings_form';
const MIN_REPORTED_HEIGHT = 100; // lager is nooit een echte formhoogte
const FALLBACK_HEIGHT = 900; // de bevestiging meet ~815px
const FALLBACK_DELAY = 2500;

let heightWasReported = false;

const getBookingIframe = () => document.getElementById(BOOKING_IFRAME_ID);

window.addEventListener('message', (event) => {
    const data = event.data;

    if (!data || typeof data !== 'object') {
        return;
    }

    // Beide id's: de form gebruikt ze door elkaar.
    if (data.id !== 'height-update' && data.id !== 'newHeight') {
        return;
    }

    const height = Number(data.height);
    const iframe = getBookingIframe();

    if (!iframe || !Number.isFinite(height) || height <= MIN_REPORTED_HEIGHT) {
        return;
    }

    heightWasReported = true;
    iframe.setAttribute('height', String(Math.round(height)));
});

document.addEventListener('DOMContentLoaded', () => {
    const iframe = getBookingIframe();

    if (!iframe) {
        return;
    }

    // Niets gerapporteerd? Geef de iframe dan ruimte in plaats van de inhoud af
    // te knippen. De hoogte-check dekt ook het geval dat het script van de
    // leverancier het attribuut al heeft gezet.
    window.setTimeout(() => {
        if (!heightWasReported && !iframe.getAttribute('height')) {
            iframe.setAttribute('height', String(FALLBACK_HEIGHT));
        }
    }, FALLBACK_DELAY);
});